import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle } from './components';
import { DialogActions, DialogContent } from './lib/styles';

export interface InfoDialogProps {
  readonly dismiss?: string;
  readonly message: string;
  readonly onDismiss: () => void;
  readonly open: boolean;
  readonly title?: string;
}

export const InfoDialog = ({ message, onDismiss, open, ...props }: InfoDialogProps) => {
  const { t } = useTranslation();
  const { dismiss = t('common.dialogs.dismiss'), title = t('common.dialogs.information_title') } =
    props;

  return (
    <Dialog open={open} onClose={onDismiss} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onDismiss}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onDismiss} color="primary">
          {dismiss}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
